import { createClient } from '@supabase/supabase-js';
import { cookieStorage } from './cookieStorage';

// --- Variables d’environnement CRA ---
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
const supabaseFunctionsUrl = process.env.REACT_APP_SUPABASE_FUNCTIONS_URL;

if (!supabaseUrl || !supabaseAnonKey) {
  // eslint-disable-next-line no-console
  console.error(
    "❌ Supabase env vars manquantes. Vérifie REACT_APP_SUPABASE_URL et REACT_APP_SUPABASE_ANON_KEY"
  );
}




// --- Client principal Supabase (base + storage + auth) ---
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: cookieStorage,
    storageKey: "artkiv-auth",
    // Désactive navigator.locks pour éviter les AbortError en cas de clients multiples
    lock: async (_name, _acquireTimeout, fn) => fn(),
  },
  global: {
    headers: { "X-Client-Info": "artkiv-web" },
  },
});

// --- URL utilitaire : fonctions Edge ---
export const getFunctionsUrl = (path = "") => {
  const clean = (path || "").replace(/^\/+/, "");
  return supabaseFunctionsUrl ? `${supabaseFunctionsUrl}/${clean}` : `/${clean}`;
};

// --- Récupération URL publique d'une image ---
export const getImageUrl = (bucket, path) => {
  const { publicURL } = supabase.storage.from(bucket).getPublicUrl(path);
  return publicURL;
};

// --- Upload image vers un bucket Supabase ---
export const uploadImage = async (file, bucket, path) => {
  try {
    if (!file || !(file instanceof File)) {
      console.error("❌ Le fichier fourni est invalide ou manquant.");
      return null;
    }

    console.log("📤 Upload image vers Supabase...");
    console.log("📦 Bucket:", bucket);
    console.log("📁 Path:", path);

    const { error } = await supabase.storage
      .from(bucket)
      .upload(path, file, {
        cacheControl: '3600',
        upsert: true,
      });

    if (error) {
      console.error("❌ Erreur Supabase Storage:", error);
      return null;
    }

    const { data: publicData, error: publicUrlError } = supabase.storage
      .from(bucket)
      .getPublicUrl(path);

    if (publicUrlError || !publicData?.publicUrl) {
      console.error("❌ Erreur ou URL manquante dans getPublicUrl:", publicUrlError);
      return null;
    }

    console.log("✅ Image uploadée avec succès:", publicData.publicUrl);
    return publicData.publicUrl;
  } catch (error) {
    console.error("❌ Exception pendant le téléchargement:", error);
    return null;
  }
};

// --- Helper pour récupérer le token Auth courant ---
export const getAccessToken = async () => {
  const { data: { session } } = await supabase.auth.getSession();
  return session?.access_token || '';
};
